import { render } from "./FinishedDisabilityPage.vue?vue&type=template&id=b2bbed4c&scoped=true"
import script from "./FinishedDisabilityPage.vue?vue&type=script&lang=js"
export * from "./FinishedDisabilityPage.vue?vue&type=script&lang=js"

import "./FinishedDisabilityPage.vue?vue&type=style&index=0&id=b2bbed4c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2bbed4c"]])

export default __exports__